import { queries } from '@/constants/general'

export interface ISsoParams {
  memberId: string
  otp: string
}

export const getSsoParams = (search: string): ISsoParams | null => {
  const params = new URLSearchParams(search)
  const memberId = params.get(queries.memberId)
  const otp = params.get(queries.otp)
  if (!memberId || !otp) {
    return null
  }
  return { memberId, otp }
}

// The path to return to once the session is established: the same page without
// the credentials, every other parameter kept.
export const buildReturnPath = (pathname: string, search: string): string => {
  const params = new URLSearchParams(search)
  params.delete(queries.memberId)
  params.delete(queries.otp)
  const rest = params.toString()
  return rest ? `${pathname}?${rest}` : pathname
}
